import { type FC } from 'react'
import { UpsellBodyLayout } from '../../Common/UpsellBodyLayout'
import { UpsellFeatureItem } from '../../Common/UpsellFeatureItem'
import AnalyticsPromo from '../../../../assets/images/upsell-analytics.png'

import './AnalyticsUpsell.scss'

export const AnalyticsUpsellBody: FC = () => {
  return (
    <UpsellBodyLayout
      image={<img src={AnalyticsPromo} alt='Analytics promo' className='zocks-border-0.5 analytics-upsell-promo object-fit-contain' />}
      heading={
        <>
          Turn data into decisions with <span className='zocks-text-primary'>Analytics</span>
        </>
      }
      description='Everything you need to understand your practice, your team, and your growth. All in one place.'
    />
  )
}

export const AnalyticsUpsellFeatures: FC = () => {
  return (
    <>
      <UpsellFeatureItem title='Meeting activity' description='Track meeting volume, types, and trends across your team over time' />
      <UpsellFeatureItem title='Performance reporting' description='Dive into the numbers behind your practice with detailed charts and tables' />
      <UpsellFeatureItem title='Firm-wide visibility' description='See how your team is performing across every dimension' className='mb-3' />
    </>
  )
}
